(function(){
  
  function getState(val) {
    let trie = {
  "0": {
    "0": {
      "0": "N\/A",
      "1": "N\/A",
      "2": "N\/A",
      "3": "N\/A",
      "4": "N\/A",
      "5": "New York",
      "6": "Puerto Rico",
      "7": "Puerto Rico",
      "8": "United States Virgin Islands",
      "9": "Puerto Rico"
    },
    "1": {
      "0": "Massachusetts",
      "1": "Massachusetts",
      "2": "Massachusetts",
      "3": "Massachusetts",
      "4": "Massachusetts",
      "5": "Massachusetts",
      "6": "Massachusetts",
      "7": "Massachusetts",
      "8": "Massachusetts",
      "9": "Massachusetts"
    },
    "2": {
      "0": "Massachusetts",
      "1": "Massachusetts",
      "2": "Massachusetts",
      "3": "Massachusetts",
      "4": "Massachusetts",
      "5": "Massachusetts",
      "6": "Massachusetts",
      "7": "Massachusetts",
      "8": "Rhode Island",
      "9": "Rhode Island"
    },
    "3": {
      "0": "New Hampshire",
      "1": "New Hampshire",
      "2": "New Hampshire",
      "3": "New Hampshire",
      "4": "New Hampshire",
      "5": "New Hampshire",
      "6": "New Hampshire",
      "7": "New Hampshire",
      "8": "New Hampshire",
      "9": "Maine"
    },
    "4": {
      "0": "Maine",
      "1": "Maine",
      "2": "Maine",
      "3": "Maine",
      "4": "Maine",
      "5": "Maine",
      "6": "Maine",
      "7": "Maine",
      "8": "Maine",
      "9": "Maine"
    },
    "5": {
      "0": "Vermont",
      "1": "Vermont",
      "2": "Vermont",
      "3": "Vermont",
      "4": "Vermont",
      "5": "Massachusetts",
      "6": "Vermont",
      "7": "Vermont",
      "8": "Vermont",
      "9": "Vermont"
    },
    "6": {
      "0": "Connecticut",
      "1": "Connecticut",
      "2": "Connecticut",
      "3": "Connecticut",
      "4": "Connecticut",
      "5": "Connecticut",
      "6": "Connecticut",
      "7": "Connecticut",
      "8": "Connecticut",
      "9": "Connecticut"
    },
    "7": {
      "0": "New Jersey",
      "1": "New Jersey",
      "2": "New Jersey",
      "3": "New Jersey",
      "4": "New Jersey",
      "5": "New Jersey",
      "6": "New Jersey",
      "7": "New Jersey",
      "8": "New Jersey",
      "9": "New Jersey"
    },
    "8": {
      "0": "New Jersey",
      "1": "New Jersey",
      "2": "New Jersey",
      "3": "New Jersey",
      "4": "New Jersey",
      "5": "New Jersey",
      "6": "New Jersey",
      "7": "New Jersey",
      "8": "New Jersey",
      "9": "New Jersey"
    },
    "9": {
      "0": "United States Armed Forces",
      "1": "United States Armed Forces",
      "2": "United States Armed Forces",
      "3": "United States Armed Forces",
      "4": "United States Armed Forces",
      "5": "United States Armed Forces",
      "6": "United States Armed Forces",
      "7": "United States Armed Forces",
      "8": "United States Armed Forces",
      "9": "United States Armed Forces"
    }
  },
  "1": {
    "0": {
      "0": "New York",
      "1": "New York",
      "2": "New York",
      "3": "New York",
      "4": "New York",
      "5": "New York",
      "6": "New York",
      "7": "New York",
      "8": "New York",
      "9": "New York"
    },
    "1": {
      "0": "New York",
      "1": "New York",
      "2": "New York",
      "3": "New York",
      "4": "New York",
      "5": "New York",
      "6": "New York",
      "7": "New York",
      "8": "New York",
      "9": "New York"
    },
    "2": {
      "0": "New York",
      "1": "New York",
      "2": "New York",
      "3": "New York",
      "4": "New York",
      "5": "New York",
      "6": "New York",
      "7": "New York",
      "8": "New York",
      "9": "New York"
    },
    "3": {
      "0": "New York",
      "1": "New York",
      "2": "New York",
      "3": "New York",
      "4": "New York",
      "5": "New York",
      "6": "New York",
      "7": "New York",
      "8": "New York",
      "9": "New York"
    },
    "4": {
      "0": "New York",
      "1": "New York",
      "2": "New York",
      "3": "New York",
      "4": "New York",
      "5": "New York",
      "6": "New York",
      "7": "New York",
      "8": "New York",
      "9": "New York"
    },
    "5": {
      "0": "Pennsylvania",
      "1": "Pennsylvania",
      "2": "Pennsylvania",
      "3": "Pennsylvania",
      "4": "Pennsylvania",
      "5": "Pennsylvania",
      "6": "Pennsylvania",
      "7": "Pennsylvania",
      "8": "Pennsylvania",
      "9": "Pennsylvania"
    },
    "6": {
      "0": "Pennsylvania",
      "1": "Pennsylvania",
      "2": "Pennsylvania",
      "3": "Pennsylvania",
      "4": "Pennsylvania",
      "5": "Pennsylvania",
      "6": "Pennsylvania",
      "7": "Pennsylvania",
      "8": "Pennsylvania",
      "9": "Pennsylvania"
    },
    "7": {
      "0": "Pennsylvania",
      "1": "Pennsylvania",
      "2": "Pennsylvania",
      "3": "Pennsylvania",
      "4": "Pennsylvania",
      "5": "Pennsylvania",
      "6": "Pennsylvania",
      "7": "Pennsylvania",
      "8": "Pennsylvania",
      "9": "Pennsylvania"
    },
    "8": {
      "0": "Pennsylvania",
      "1": "Pennsylvania",
      "2": "Pennsylvania",
      "3": "Pennsylvania",
      "4": "Pennsylvania",
      "5": "Pennsylvania",
      "6": "Pennsylvania",
      "7": "Pennsylvania",
      "8": "Pennsylvania",
      "9": "Pennsylvania"
    },
    "9": {
      "0": "Pennsylvania",
      "1": "Pennsylvania",
      "2": "Pennsylvania",
      "3": "Pennsylvania",
      "4": "Pennsylvania",
      "5": "Pennsylvania",
      "6": "Pennsylvania",
      "7": "Delaware",
      "8": "Delaware",
      "9": "Delaware"
    }
  },
  "2": {
    "0": {
      "0": "D.C.",
      "1": "Virginia",
      "2": "D.C.",
      "3": "D.C.",
      "4": "D.C.",
      "5": "D.C.",
      "6": "Maryland",
      "7": "Maryland",
      "8": "Maryland",
      "9": "Maryland"
    },
    "1": {
      "0": "Maryland",
      "1": "Maryland",
      "2": "Maryland",
      "3": "N\/A",
      "4": "Maryland",
      "5": "Maryland",
      "6": "Maryland",
      "7": "Maryland",
      "8": "Maryland",
      "9": "Maryland"
    },
    "2": {
      "0": "Virginia",
      "1": "Virginia",
      "2": "Virginia",
      "3": "Virginia",
      "4": "Virginia",
      "5": "Virginia",
      "6": "Virginia",
      "7": "Virginia",
      "8": "Virginia",
      "9": "Virginia"
    },
    "3": {
      "0": "Virginia",
      "1": "Virginia",
      "2": "Virginia",
      "3": "Virginia",
      "4": "Virginia",
      "5": "Virginia",
      "6": "Virginia",
      "7": "Virginia",
      "8": "Virginia",
      "9": "Virginia"
    },
    "4": {
      "0": "Virginia",
      "1": "Virginia",
      "2": "Virginia",
      "3": "Virginia",
      "4": "Virginia",
      "5": "Virginia",
      "6": "Virginia",
      "7": "West Virginia",
      "8": "West Virginia",
      "9": "West Virginia"
    },
    "5": {
      "0": "West Virginia",
      "1": "West Virginia",
      "2": "West Virginia",
      "3": "West Virginia",
      "4": "West Virginia",
      "5": "West Virginia",
      "6": "West Virginia",
      "7": "West Virginia",
      "8": "West Virginia",
      "9": "West Virginia"
    },
    "6": {
      "0": "West Virginia",
      "1": "West Virginia",
      "2": "West Virginia",
      "3": "West Virginia",
      "4": "West Virginia",
      "5": "West Virginia",
      "6": "West Virginia",
      "7": "West Virginia",
      "8": "West Virginia",
      "9": "N\/A"
    },
    "7": {
      "0": "North Carolina",
      "1": "North Carolina",
      "2": "North Carolina",
      "3": "North Carolina",
      "4": "North Carolina",
      "5": "North Carolina",
      "6": "North Carolina",
      "7": "North Carolina",
      "8": "North Carolina",
      "9": "North Carolina"
    },
    "8": {
      "0": "North Carolina",
      "1": "North Carolina",
      "2": "North Carolina",
      "3": "North Carolina",
      "4": "North Carolina",
      "5": "North Carolina",
      "6": "North Carolina",
      "7": "North Carolina",
      "8": "North Carolina",
      "9": "North Carolina"
    },
    "9": {
      "0": "South Carolina",
      "1": "South Carolina",
      "2": "South Carolina",
      "3": "South Carolina",
      "4": "South Carolina",
      "5": "South Carolina",
      "6": "South Carolina",
      "7": "South Carolina",
      "8": "South Carolina",
      "9": "South Carolina"
    }
  },
  "3": {
    "0": {
      "0": "Georgia",
      "1": "Georgia",
      "2": "Georgia",
      "3": "Georgia",
      "4": "Georgia",
      "5": "Georgia",
      "6": "Georgia",
      "7": "Georgia",
      "8": "Georgia",
      "9": "Georgia"
    },
    "1": {
      "0": "Georgia",
      "1": "Georgia",
      "2": "Georgia",
      "3": "Georgia",
      "4": "Georgia",
      "5": "Georgia",
      "6": "Georgia",
      "7": "Georgia",
      "8": "Georgia",
      "9": "Georgia"
    },
    "2": {
      "0": "Florida",
      "1": "Florida",
      "2": "Florida",
      "3": "Florida",
      "4": "Florida",
      "5": "Florida",
      "6": "Florida",
      "7": "Florida",
      "8": "Florida",
      "9": "Florida"
    },
    "3": {
      "0": "Florida",
      "1": "Florida",
      "2": "Florida",
      "3": "Florida",
      "4": "Florida",
      "5": "Florida",
      "6": "Florida",
      "7": "Florida",
      "8": "Florida",
      "9": "Florida"
    },
    "4": {
      "0": "United States armed forces",
      "1": "Florida",
      "2": "Florida",
      "3": "N\/A",
      "4": "Florida",
      "5": "N\/A",
      "6": "Florida",
      "7": "Florida",
      "8": "N\/A",
      "9": "Florida"
    },
    "5": {
      "0": "Alabama",
      "1": "Alabama",
      "2": "Alabama",
      "3": "N\/A",
      "4": "Alabama",
      "5": "Alabama",
      "6": "Alabama",
      "7": "Alabama",
      "8": "Alabama",
      "9": "Alabama"
    },
    "6": {
      "0": "Alabama",
      "1": "Alabama",
      "2": "Alabama",
      "3": "Alabama",
      "4": "Alabama",
      "5": "Alabama",
      "6": "Alabama",
      "7": "Alabama",
      "8": "Alabama",
      "9": "Alabama"
    },
    "7": {
      "0": "Tennessee",
      "1": "Tennessee",
      "2": "Tennessee",
      "3": "Tennessee",
      "4": "Tennessee",
      "5": "Tennessee",
      "6": "Tennessee",
      "7": "Tennessee",
      "8": "Tennessee",
      "9": "Tennessee"
    },
    "8": {
      "0": "Tennessee",
      "1": "Tennessee",
      "2": "Tennessee",
      "3": "Tennessee",
      "4": "Tennessee",
      "5": "Tennessee",
      "6": "Mississippi",
      "7": "Mississippi",
      "8": "Mississippi",
      "9": "Mississippi"
    },
    "9": {
      "0": "Mississippi",
      "1": "Mississippi",
      "2": "Mississippi",
      "3": "Mississippi",
      "4": "Mississippi",
      "5": "Mississippi",
      "6": "Mississippi",
      "7": "Mississippi",
      "8": "Georgia",
      "9": "Georgia"
    }
  },
  "4": {
    "0": {
      "0": "Kentucky",
      "1": "Kentucky",
      "2": "Kentucky",
      "3": "Kentucky",
      "4": "Kentucky",
      "5": "Kentucky",
      "6": "Kentucky",
      "7": "Kentucky",
      "8": "Kentucky",
      "9": "Kentucky"
    },
    "1": {
      "0": "Kentucky",
      "1": "Kentucky",
      "2": "Kentucky",
      "3": "Kentucky",
      "4": "Kentucky",
      "5": "Kentucky",
      "6": "Kentucky",
      "7": "Kentucky",
      "8": "Kentucky",
      "9": "N\/A"
    },
    "2": {
      "0": "Kentucky",
      "1": "Kentucky",
      "2": "Kentucky",
      "3": "Kentucky",
      "4": "Kentucky",
      "5": "Kentucky",
      "6": "Kentucky",
      "7": "Kentucky",
      "8": "N\/A",
      "9": "N\/A"
    },
    "3": {
      "0": "Ohio",
      "1": "Ohio",
      "2": "Ohio",
      "3": "Ohio",
      "4": "Ohio",
      "5": "Ohio",
      "6": "Ohio",
      "7": "Ohio",
      "8": "Ohio",
      "9": "Ohio"
    },
    "4": {
      "0": "Ohio",
      "1": "Ohio",
      "2": "Ohio",
      "3": "Ohio",
      "4": "Ohio",
      "5": "Ohio",
      "6": "Ohio",
      "7": "Ohio",
      "8": "Ohio",
      "9": "Ohio"
    },
    "5": {
      "0": "Ohio",
      "1": "Ohio",
      "2": "Ohio",
      "3": "Ohio",
      "4": "Ohio",
      "5": "Ohio",
      "6": "Ohio",
      "7": "Ohio",
      "8": "Ohio",
      "9": "Ohio"
    },
    "6": {
      "0": "Indiana",
      "1": "Indiana",
      "2": "Indiana",
      "3": "Indiana",
      "4": "Indiana",
      "5": "Indiana",
      "6": "Indiana",
      "7": "Indiana",
      "8": "Indiana",
      "9": "Indiana"
    },
    "7": {
      "0": "Indiana",
      "1": "Indiana",
      "2": "Indiana",
      "3": "Indiana",
      "4": "Indiana",
      "5": "Indiana",
      "6": "Indiana",
      "7": "Indiana",
      "8": "Indiana",
      "9": "Indiana"
    },
    "8": {
      "0": "Michigan",
      "1": "Michigan",
      "2": "Michigan",
      "3": "Michigan",
      "4": "Michigan",
      "5": "Michigan",
      "6": "Michigan",
      "7": "Michigan",
      "8": "Michigan",
      "9": "Michigan"
    },
    "9": {
      "0": "Michigan",
      "1": "Michigan",
      "2": "Michigan",
      "3": "Michigan",
      "4": "Michigan",
      "5": "Michigan",
      "6": "Michigan",
      "7": "Michigan",
      "8": "Michigan",
      "9": "Michigan"
    }
  },
  "5": {
    "0": {
      "0": "Iowa",
      "1": "Iowa",
      "2": "Iowa",
      "3": "Iowa",
      "4": "Iowa",
      "5": "Iowa",
      "6": "Iowa",
      "7": "Iowa",
      "8": "Iowa",
      "9": "Iowa"
    },
    "1": {
      "0": "Iowa",
      "1": "Iowa",
      "2": "Iowa",
      "3": "Iowa",
      "4": "Iowa",
      "5": "Iowa",
      "6": "Iowa",
      "7": "N\/A",
      "8": "N\/A",
      "9": "N\/A"
    },
    "2": {
      "0": "Iowa",
      "1": "Iowa",
      "2": "Iowa",
      "3": "Iowa",
      "4": "Iowa",
      "5": "Iowa",
      "6": "Iowa",
      "7": "Iowa",
      "8": "Iowa",
      "9": "N\/A"
    },
    "3": {
      "0": "Wisconsin",
      "1": "Wisconsin",
      "2": "Wisconsin",
      "3": "N\/A",
      "4": "Wisconsin",
      "5": "Wisconsin",
      "6": "N\/A",
      "7": "Wisconsin",
      "8": "Wisconsin",
      "9": "Wisconsin"
    },
    "4": {
      "0": "Wisconsin",
      "1": "Wisconsin",
      "2": "Wisconsin",
      "3": "Wisconsin",
      "4": "Wisconsin",
      "5": "Wisconsin",
      "6": "Wisconsin",
      "7": "Wisconsin",
      "8": "Wisconsin",
      "9": "Wisconsin"
    },
    "5": {
      "0": "Minnesota",
      "1": "Minnesota",
      "2": "N\/A",
      "3": "Minnesota",
      "4": "Minnesota",
      "5": "Minnesota",
      "6": "Minnesota",
      "7": "Minnesota",
      "8": "Minnesota",
      "9": "Minnesota"
    },
    "6": {
      "0": "Minnesota",
      "1": "Minnesota",
      "2": "Minnesota",
      "3": "Minnesota",
      "4": "Minnesota",
      "5": "Minnesota",
      "6": "Minnesota",
      "7": "Minnesota",
      "8": "N\/A",
      "9": "D.C."
    },
    "7": {
      "0": "South Dakota",
      "1": "South Dakota",
      "2": "South Dakota",
      "3": "South Dakota",
      "4": "South Dakota",
      "5": "South Dakota",
      "6": "South Dakota",
      "7": "South Dakota",
      "8": "N\/A",
      "9": "N\/A"
    },
    "8": {
      "0": "North Dakota",
      "1": "North Dakota",
      "2": "North Dakota",
      "3": "North Dakota",
      "4": "North Dakota",
      "5": "North Dakota",
      "6": "North Dakota",
      "7": "North Dakota",
      "8": "North Dakota",
      "9": "N\/A"
    },
    "9": {
      "0": "Montana",
      "1": "Montana",
      "2": "Montana",
      "3": "Montana",
      "4": "Montana",
      "5": "Montana",
      "6": "Montana",
      "7": "Montana",
      "8": "Montana",
      "9": "Montana"
    }
  },
  "6": {
    "0": {
      "0": "Illinois",
      "1": "Illinois",
      "2": "Illinois",
      "3": "Illinois",
      "4": "Illinois",
      "5": "Illinois",
      "6": "Illinois",
      "7": "Illinois",
      "8": "Illinois",
      "9": "Illinois"
    },
    "1": {
      "0": "Illinois",
      "1": "Illinois",
      "2": "Illinois",
      "3": "Illinois",
      "4": "Illinois",
      "5": "Illinois",
      "6": "Illinois",
      "7": "Illinois",
      "8": "Illinois",
      "9": "Illinois"
    },
    "2": {
      "0": "Illinois",
      "1": "N\/A",
      "2": "Illinois",
      "3": "Illinois",
      "4": "Illinois",
      "5": "Illinois",
      "6": "Illinois",
      "7": "Illinois",
      "8": "Illinois",
      "9": "Illinois"
    },
    "3": {
      "0": "Missouri",
      "1": "Missouri",
      "2": "N\/A",
      "3": "Missouri",
      "4": "Missouri",
      "5": "Missouri",
      "6": "Missouri",
      "7": "Missouri",
      "8": "Missouri",
      "9": "Missouri"
    },
    "4": {
      "0": "Missouri",
      "1": "Missouri",
      "2": "N\/A",
      "3": "N\/A",
      "4": "Missouri",
      "5": "Missouri",
      "6": "Missouri",
      "7": "Missouri",
      "8": "Missouri",
      "9": "Missouri"
    },
    "5": {
      "0": "Missouri",
      "1": "Missouri",
      "2": "Missouri",
      "3": "Missouri",
      "4": "Missouri",
      "5": "Missouri",
      "6": "Missouri",
      "7": "Missouri",
      "8": "Missouri",
      "9": "N\/A"
    },
    "6": {
      "0": "Kansas",
      "1": "Kansas",
      "2": "Kansas",
      "3": "N\/A",
      "4": "Kansas",
      "5": "Kansas",
      "6": "Kansas",
      "7": "Kansas",
      "8": "Kansas",
      "9": "Kansas"
    },
    "7": {
      "0": "Kansas",
      "1": "Kansas",
      "2": "Kansas",
      "3": "Kansas",
      "4": "Kansas",
      "5": "Kansas",
      "6": "Kansas",
      "7": "Kansas",
      "8": "Kansas",
      "9": "Kansas"
    },
    "8": {
      "0": "Nebraska",
      "1": "Nebraska",
      "2": "N\/A",
      "3": "Nebraska",
      "4": "Nebraska",
      "5": "Nebraska",
      "6": "Nebraska",
      "7": "Nebraska",
      "8": "Nebraska",
      "9": "Nebraska"
    },
    "9": {
      "0": "Nebraska",
      "1": "Nebraska",
      "2": "Nebraska",
      "3": "Nebraska",
      "4": "N\/A",
      "5": "N\/A",
      "6": "N\/A",
      "7": "N\/A",
      "8": "N\/A",
      "9": "N\/A"
    }
  },
  "7": {
    "0": {
      "0": "Louisiana",
      "1": "Louisiana",
      "2": "N\/A",
      "3": "Louisiana",
      "4": "Louisiana",
      "5": "Louisiana",
      "6": "Louisiana",
      "7": "Louisiana",
      "8": "Louisiana",
      "9": "N\/A"
    },
    "1": {
      "0": "Louisiana",
      "1": "Louisiana",
      "2": "Louisiana",
      "3": "Louisiana",
      "4": "Louisiana",
      "5": "N\/A",
      "6": "Arkansas",
      "7": "Arkansas",
      "8": "Arkansas",
      "9": "Arkansas"
    },
    "2": {
      "0": "Arkansas",
      "1": "Arkansas",
      "2": "Arkansas",
      "3": "Arkansas",
      "4": "Arkansas",
      "5": "Arkansas",
      "6": "Arkansas",
      "7": "Arkansas",
      "8": "Arkansas",
      "9": "Arkansas"
    },
    "3": {
      "0": "Oklahoma",
      "1": "Oklahoma",
      "2": "N\/A",
      "3": "Texas",
      "4": "Oklahoma",
      "5": "Oklahoma",
      "6": "Oklahoma",
      "7": "Oklahoma",
      "8": "Oklahoma",
      "9": "Oklahoma"
    },
    "4": {
      "0": "Oklahoma",
      "1": "Oklahoma",
      "2": "N\/A",
      "3": "Oklahoma",
      "4": "Oklahoma",
      "5": "Oklahoma",
      "6": "Oklahoma",
      "7": "Oklahoma",
      "8": "Oklahoma",
      "9": "Oklahoma"
    },
    "5": {
      "0": "Texas",
      "1": "Texas",
      "2": "Texas",
      "3": "Texas",
      "4": "Texas",
      "5": "Texas",
      "6": "Texas",
      "7": "Texas",
      "8": "Texas",
      "9": "Texas"
    },
    "6": {
      "0": "Texas",
      "1": "Texas",
      "2": "Texas",
      "3": "Texas",
      "4": "Texas",
      "5": "Texas",
      "6": "Texas",
      "7": "Texas",
      "8": "Texas",
      "9": "Texas"
    },
    "7": {
      "0": "Texas",
      "1": "Texas",
      "2": "Texas",
      "3": "Texas",
      "4": "Texas",
      "5": "Texas",
      "6": "Texas",
      "7": "Texas",
      "8": "Texas",
      "9": "Texas"
    },
    "8": {
      "0": "Texas",
      "1": "Texas",
      "2": "Texas",
      "3": "Texas",
      "4": "Texas",
      "5": "Texas",
      "6": "Texas",
      "7": "Texas",
      "8": "Texas",
      "9": "Texas"
    },
    "9": {
      "0": "Texas",
      "1": "Texas",
      "2": "Texas",
      "3": "Texas",
      "4": "Texas",
      "5": "Texas",
      "6": "Texas",
      "7": "Texas",
      "8": "Texas",
      "9": "Texas"
    }
  },
  "8": {
    "0": {
      "0": "Colorado",
      "1": "Colorado",
      "2": "Colorado",
      "3": "Colorado",
      "4": "Colorado",
      "5": "Colorado",
      "6": "Colorado",
      "7": "Colorado",
      "8": "Colorado",
      "9": "Colorado"
    },
    "1": {
      "0": "Colorado",
      "1": "Colorado",
      "2": "Colorado",
      "3": "Colorado",
      "4": "Colorado",
      "5": "Colorado",
      "6": "Colorado",
      "7": "N\/A",
      "8": "N\/A",
      "9": "N\/A"
    },
    "2": {
      "0": "Wyoming",
      "1": "Wyoming",
      "2": "Wyoming",
      "3": "Wyoming",
      "4": "Wyoming",
      "5": "Wyoming",
      "6": "Wyoming",
      "7": "Wyoming",
      "8": "Wyoming",
      "9": "Wyoming"
    },
    "3": {
      "0": "Wyoming",
      "1": "Wyoming",
      "2": "Idaho",
      "3": "Idaho",
      "4": "Idaho",
      "5": "Idaho",
      "6": "Idaho",
      "7": "Idaho",
      "8": "Idaho",
      "9": "N\/A"
    },
    "4": {
      "0": "Utah",
      "1": "Utah",
      "2": "Utah",
      "3": "Utah",
      "4": "Utah",
      "5": "Utah",
      "6": "Utah",
      "7": "Utah",
      "8": "N\/A",
      "9": "N\/A"
    },
    "5": {
      "0": "Arizona",
      "1": "Arizona",
      "2": "Arizona",
      "3": "Arizona",
      "4": "N\/A",
      "5": "Arizona",
      "6": "Arizona",
      "7": "Arizona",
      "8": "N\/A",
      "9": "Arizona"
    },
    "6": {
      "0": "Arizona",
      "1": "N\/A",
      "2": "N\/A",
      "3": "Arizona",
      "4": "Arizona",
      "5": "Arizona",
      "6": "N\/A",
      "7": "N\/A",
      "8": "N\/A",
      "9": "N\/A"
    },
    "7": {
      "0": "New Mexico",
      "1": "New Mexico",
      "2": "N\/A",
      "3": "New Mexico",
      "4": "New Mexico",
      "5": "New Mexico",
      "6": "N\/A",
      "7": "New Mexico",
      "8": "New Mexico",
      "9": "New Mexico"
    },
    "8": {
      "0": "New Mexico",
      "1": "New Mexico",
      "2": "New Mexico",
      "3": "New Mexico",
      "4": "New Mexico",
      "5": "Texas",
      "6": "N\/A",
      "7": "N\/A",
      "8": "N\/A",
      "9": "Nevada"
    },
    "9": {
      "0": "Nevada",
      "1": "Nevada",
      "2": "N\/A",
      "3": "Nevada",
      "4": "Nevada",
      "5": "Nevada",
      "6": "N\/A",
      "7": "Nevada",
      "8": "Nevada",
      "9": "N\/A"
    }
  },
  "9": {
    "0": {
      "0": "California",
      "1": "California",
      "2": "California",
      "3": "California",
      "4": "California",
      "5": "California",
      "6": "California",
      "7": "California",
      "8": "California",
      "9": "N\/A"
    },
    "1": {
      "0": "California",
      "1": "California",
      "2": "California",
      "3": "California",
      "4": "California",
      "5": "California",
      "6": "California",
      "7": "California",
      "8": "California",
      "9": "California"
    },
    "2": {
      "0": "California",
      "1": "California",
      "2": "California",
      "3": "California",
      "4": "California",
      "5": "California",
      "6": "California",
      "7": "California",
      "8": "California",
      "9": "N\/A"
    },
    "3": {
      "0": "California",
      "1": "California",
      "2": "California",
      "3": "California",
      "4": "California",
      "5": "California",
      "6": "California",
      "7": "California",
      "8": "California",
      "9": "California"
    },
    "4": {
      "0": "California",
      "1": "California",
      "2": "California",
      "3": "California",
      "4": "California",
      "5": "California",
      "6": "California",
      "7": "California",
      "8": "California",
      "9": "California"
    },
    "5": {
      "0": "California",
      "1": "California",
      "2": "California",
      "3": "California",
      "4": "California",
      "5": "California",
      "6": "California",
      "7": "California",
      "8": "California",
      "9": "California"
    },
    "6": {
      "0": "California",
      "1": "California",
      "2": "United States armed forces",
      "3": "United States armed forces",
      "4": "United States armed forces",
      "5": "United States armed forces",
      "6": "United States armed forces",
      "7": "Hawaii",
      "8": "Hawaii",
      "9": "Guam"
    },
    "7": {
      "0": "Oregon",
      "1": "Oregon",
      "2": "Oregon",
      "3": "Oregon",
      "4": "Oregon",
      "5": "Oregon",
      "6": "Oregon",
      "7": "Oregon",
      "8": "Oregon",
      "9": "Oregon"
    },
    "8": {
      "0": "Washington",
      "1": "Washington",
      "2": "Washington",
      "3": "Washington",
      "4": "Washington",
      "5": "Washington",
      "6": "Washington",
      "7": "N\/A",
      "8": "Washington",
      "9": "Washington"
    },
    "9": {
      "0": "Washington",
      "1": "Washington",
      "2": "Washington",
      "3": "Washington",
      "4": "Washington",
      "5": "Alaska",
      "6": "Alaska",
      "7": "Alaska",
      "8": "Alaska",
      "9": "Alaska"
    }
  }
}
  	
    let input_values = val.split('');
    return(trie[input_values[0]][input_values[1]][input_values[2]]);
    
  }
  
  function checkZipcode(val, string) {
    one = val.split('')[0] + "****";
    two = val.split('')[0] + val.split('')[1] + "***";
    three = val.split('')[0] + val.split('')[1] + val.split('')[2] + "**";
    four = val.split('')[0] + val.split('')[1] + val.split('')[2] + val.split('')[3] + "*";
    return(string.includes(val) || string.includes(one) || string.includes(two) || string.includes(three) || string.includes(four));
  }
  
  function notValid(new_text) {
    document.getElementsByClassName('shipping-restrictions-input-wrapper')[0].remove();
    document.getElementsByClassName('shipping-restrictions-description')[0].innerHTML = new_text;
  }
  
  document.getElementById('shipping-restrictions-button').addEventListener('click', function(){
    let cart_restrictions = JSON.parse(document.getElementById('shipping_restrictions').textContent);
    
  	let input_value = document.getElementById('shipping-restrictions-zipcode').value.toString();
    
    if (input_value.length === 5) {

      let state = getState(input_value);
      let invalid_zipcode = checkZipcode(input_value, cart_restrictions.zips);
      let is_valid_email = cart_restrictions.is_valid;

      if (!cart_restrictions.states.includes(state) && !invalid_zipcode && is_valid_email !== 'false') {
        document.getElementById("shipping-restrictions").remove();
      } else {
        notValid(cart_restrictions.fail_text);
      }
    } else {
      alert('Please enter a valid zipcode.'); 
    }
  });
      
})();